
import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import HtmlClass from '@/core/services/LayoutService';
import KTLoader from '@/components/Loader.vue';

import { Actions } from '@/store/enums/StoreEnums';
import {
  Actions as AuthActions,
  Getters as AuthGetters,
} from '@/store/enums/AuthEnums';
import {
  // toolbarDisplay,
  loaderEnabled,
  contentWidthFluid,
  loaderLogo,
  asideEnabled,
  subheaderDisplay,
  themeLightLogo,
  themeDarkLogo,
} from '@/core/helpers/config';
import store from '@/store';

export default defineComponent({
  name: 'Layout',
  components: {
    KTLoader,
  },
  mounted() {
    setTimeout(() => {
      // Remove page loader after some time
      store.dispatch(Actions.REMOVE_BODY_CLASSNAME, 'page-loading');
    }, 500);
  },

  setup() {
    // show page loading
    store.dispatch(Actions.ADD_BODY_CLASSNAME, 'page-loading');

    // initialize html element classes
    HtmlClass.init();

    return {
      loaderEnabled,
      contentWidthFluid,
      loaderLogo,
      asideEnabled,
      subheaderDisplay,
      themeLightLogo,
      themeDarkLogo,
    };
  },
});
